import { DocumentMaster } from "./DocumentMaster.model";

export class TestimonialMaster{
    testimonialMasterId:number;
    public fileType:string;
    public fileName:string;
    public filePath:string;
    public pageNumber :number;
    public pageSize:number;
    public testimonialImage:DocumentMaster;
    public name:string;
    public description:string;
}